"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpotShiftStatusType = exports.SpotShiftKey = void 0;
var SpotShiftKey;
(function (SpotShiftKey) {
    SpotShiftKey["CLAIMED"] = "claimedShifts";
    SpotShiftKey["UNCLAIMED"] = "unclaimedShifts";
})(SpotShiftKey || (exports.SpotShiftKey = SpotShiftKey = {}));
var SpotShiftStatusType;
(function (SpotShiftStatusType) {
    SpotShiftStatusType[SpotShiftStatusType["PENDING"] = 0] = "PENDING";
    SpotShiftStatusType[SpotShiftStatusType["ACCEPTED"] = 1] = "ACCEPTED";
    SpotShiftStatusType[SpotShiftStatusType["COMPLETED"] = 2] = "COMPLETED";
    SpotShiftStatusType[SpotShiftStatusType["PAID"] = 3] = "PAID";
    SpotShiftStatusType[SpotShiftStatusType["NO_SHOW"] = 4] = "NO_SHOW";
})(SpotShiftStatusType || (exports.SpotShiftStatusType = SpotShiftStatusType = {}));
